// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"180":"video","303":"widget","495":"feed"}[chunkId] + "." + {"180":"bed6cd715da7d23bd4a3","303":"363e47371f357e4ac83e","495":"84aa2a698b4f6931fe07"}[chunkId] + ".js";
};